var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('gmap-autocomplete',{staticClass:"address-autocomplete",attrs:{"value":_vm.addressText,"select-first-on-enter":_vm.selectFirstOnEnter,"placeholder":_vm.placeholder,"options":_vm.options},on:{"place_changed":_vm.setPlace}})}
var staticRenderFns = []

export { render, staticRenderFns }